import React from 'react'
// import '../styles/skeleton/skeleton.scss'

const Skeleton = (props) => {
            const {type}=props;
  return (
    <div  className={`skeleton ${type}`}>
      
    </div>
  )
}

export default Skeleton;
